/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from 'react'
import { Col, Image, List, Row, Space } from 'antd'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import { ConfirmDailog, EventModal, LoadingView } from 'Components/modal'
import { MyTheme } from 'Components/common/Theme'
import PointSummary from './PointSummary'
import { appConfig } from 'config'
import { ImageFallback } from 'helpers/constanst'
import { PrimaryButton } from 'Components/button'
import { GiftOutlined, StarOutlined } from '@ant-design/icons'
import { redeemRewardAPI, rewardListAPI } from 'Store/member-reward/api'
import { RedeemRewardReq, RewardData, RewardListReq } from 'Store/member-reward/types'
import {
  selectRewardActionEvent,
  selectRewardList,
  selectRewardListEvent,
} from 'Store/member-reward/selector'
import { numberWithComma } from 'helpers/format'
import { selectMemberPointInfo } from 'Store/member-point/selector'
import { clearEventAction } from 'Store/member-reward/actions'

type Props = {
  isShow: boolean
  onClose: () => void
  onSuccess: () => void
  id: number
} & ReduxProps

const PointReward = (props: Props) => {
  const { isShow, onClose, currentUser, list, id, listEvent, pointInfo, onSuccess, actionEvent } = props
  const [confirmDialog, setConfirmDialog] = useState(false)
  const [selectedReward, setSelectedReward] = useState(undefined as RewardData | undefined)
  const currentPoint = pointInfo?.data?.point || 0
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  useEffect(() => {
    if (isShow) {
      onGetList()
    }
  }, [isShow])

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    setConfirmDialog(false)
    clearEvent()
    onSuccess()
  }

  const dispatch = useDispatch()

  const onGetList = (): void => {
    const req: RewardListReq = {
      keyword: '',
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      order_by: 'id',
      sort: 'desc',
      status: 'active',
    }
    dispatch(rewardListAPI(req, currentUser.accessToken))
  }

  const onRedeem = (): void => {
    const req: RedeemRewardReq = {
      member_id: id,
      redeem_item_id: selectedReward?.id || 0,
    }
    dispatch(redeemRewardAPI(req, currentUser.accessToken))
  }

  const renderImage = (img: string) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + img} fallback={ImageFallback} />
  )

  const renderDescription = (item: RewardData) => {
    const pointNotEnough = currentPoint < item.redeem_point || item.quantity <= 0
    return (
      <Row gutter={[8, 8]} justify="space-between" align="top">
        <Col md={15} xs={24}>
          <Space direction="vertical">
            {item.description && <Description>{item.description}</Description>}
            <Remain>
              <GiftOutlined /> ของรางวัลคงเหลือ {numberWithComma(item.quantity)} รายการ
            </Remain>
            <Point>
              <StarOutlined /> {numberWithComma(item.redeem_point)} คะแนน
            </Point>
          </Space>
        </Col>
        <Col md={7}>
          <PrimaryButton
            text={pointNotEnough ? 'คะแนนไม่เพียงพอ' : 'แลกของรางวัล'}
            onClick={() => {
              setSelectedReward(item)
              setConfirmDialog(true)
            }}
            disabled={pointNotEnough}
          />
        </Col>
      </Row>
    )
  }

  const ConfirmRedeemDailog = (
    <ConfirmDailog
      title="ยืนยันการแลกของรางวัล"
      description={`คุณแน่ใจที่จะใช้คะแนน ${selectedReward?.redeem_point} คะแนนแลกของรางวัล ${selectedReward?.title} หรือไม่?`}
      confirmBtnTxt="ยืนยัน"
      isShow={confirmDialog}
      handleOk={onRedeem}
      handleCancel={() => setConfirmDialog(false)}
    />
  )

  return (
    <DetailDrawer
      title={`แลกของรางวัล`}
      width={'50%'}
      onCloseDrawer={onClose}
      visible={isShow}
      footer={null}
      maskClosable={true}
    >
      {ConfirmRedeemDailog}
      <StickyHeader>
        <PointSummary id={id} visible={isShow} />
      </StickyHeader>
      <Row>
        <Col span={24}>
          <Header>ของรางวัล</Header>
        </Col>
        <Col span={24}>
          <List
            itemLayout="horizontal"
            dataSource={list.data || []}
            renderItem={item => (
              <List.Item>
                <List.Item.Meta
                  avatar={renderImage(item.image_url)}
                  title={item.title}
                  description={renderDescription(item)}
                />
              </List.Item>
            )}
          />
        </Col>
      </Row>
      <LoadingView isShow={listEvent.IsLoading} />
      <EventModal
        event={[actionEvent]}
        enable={true}
        successCalback={onEventSuccess}
        errorCalback={clearEvent}
      />
    </DetailDrawer>
  )
}

const StickyHeader = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: -25px;
  background-color: #f8fafb;
  z-index: 1;
`

const Header = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`
const Point = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 100%;
  height: 100px;
  object-fit: cover;
`

const Description = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const Remain = styled(Description)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectRewardList(state),
    listEvent: selectRewardListEvent(state),
    pointInfo: selectMemberPointInfo(state),
    actionEvent: selectRewardActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PointReward)
